const config = {
    BACKEND_URL: process.env.REACT_APP_BACKEND_URL || '',
    GOOGLE_OAUTH_CLIENT_ID: process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID || '',
    FRONTEND_ORIGIN: process.env.REACT_APP_FRONTEND_ORIGIN || '',
};

export default config;